import React, { useLayoutEffect, useRef, useState } from "react";
import RichText from "./RichText";
import { C } from "./theme";

// Texte de slide éditable sur place : mis en forme au repos, zone de saisie au clic,
// avec la même typographie pour que la mise en page ne saute pas.
const EditableText = ({ value, onChange, editable, style, placeholder, rich = true, singleLine, label }) => {
  const [editing, setEditing] = useState(false);
  const ref = useRef(null);

  useLayoutEffect(() => {
    if (!editing || !ref.current) return;
    ref.current.style.height = "auto";
    ref.current.style.height = `${ref.current.scrollHeight}px`;
  }, [editing, value]);

  if (editable && editing) {
    return (
      <textarea
        ref={ref}
        autoFocus
        aria-label={label}
        value={value || ""}
        rows={1}
        onChange={(event) => onChange(singleLine ? event.target.value.replace(/\n/g, " ") : event.target.value)}
        onBlur={() => setEditing(false)}
        onKeyDown={(event) => {
          if (event.key === "Escape" || (singleLine && event.key === "Enter")) {
            event.preventDefault();
            event.currentTarget.blur();
          }
        }}
        // « font » d'abord : posé après la taille ou la police du texte, le raccourci les remettait à zéro.
        style={{
          font: "inherit", ...style, display: "block", width: "100%", resize: "none", overflow: "hidden", border: "none",
          outline: `2px solid ${C.blue}`, outlineOffset: 2, background: "transparent", padding: 0,
          margin: 0, whiteSpace: "pre-wrap",
        }}
      />
    );
  }

  const shown = rich
    ? <RichText text={value} style={{ ...style, margin: 0 }} placeholder={editable ? placeholder : undefined} />
    : (
      <div style={{ ...style, margin: 0, whiteSpace: style?.whiteSpace || "pre-wrap",
        ...(value ? {} : { color: C.line, fontStyle: "italic" }) }}>
        {value || (editable ? placeholder : "")}
      </div>
    );
  if (!editable) return shown;
  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={label ? `Modifier : ${label}` : "Modifier le texte"}
      onClick={() => setEditing(true)}
      onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); setEditing(true); } }}
      className="offer-editable"
      style={{ cursor: "text", borderRadius: 2 }}
    >
      {shown}
    </div>
  );
};

export default EditableText;
